
import type {
  CopilotBrowserToolResult,
  runCopilotToolProposal
} from "../copilotApply";
import type {
  LiveRequirementDeriveRequest,
  LiveRequirementDeriveResult,
  ScopedOverridePreviewRequest,
  ScopedOverridePreviewResult
} from "../impactPreview";

interface ImpactPreviewModule {
  buildScopedOverridePreview: (
    request: ScopedOverridePreviewRequest
  ) => ScopedOverridePreviewResult;
  deriveLiveRequirements: (
    request: LiveRequirementDeriveRequest
  ) => LiveRequirementDeriveResult;
}

type RunCopilotToolProposal = typeof runCopilotToolProposal;

interface CopilotApplyModule {
  runCopilotToolProposal: RunCopilotToolProposal;
}

let impactPreviewModulePromise: Promise<ImpactPreviewModule> | null = null;
let copilotApplyModulePromise: Promise<CopilotApplyModule> | null = null;

const loadImpactPreviewModule = (): Promise<ImpactPreviewModule> => {
  impactPreviewModulePromise ??= import("../impactPreview");

  return impactPreviewModulePromise;
};

export const buildScopedOverridePreviewAsync = async (
  request: ScopedOverridePreviewRequest
): Promise<ScopedOverridePreviewResult> => {
  const { buildScopedOverridePreview } = await loadImpactPreviewModule();

  return buildScopedOverridePreview(request);
};

export const deriveLiveRequirementsAsync = async (
  request: LiveRequirementDeriveRequest
): Promise<LiveRequirementDeriveResult> => {
  const { deriveLiveRequirements } = await loadImpactPreviewModule();

  return deriveLiveRequirements(request);
};

const loadCopilotApplyModule = (): Promise<CopilotApplyModule> => {
  copilotApplyModulePromise ??= import("../copilotApply");

  return copilotApplyModulePromise;
};

export const runCopilotToolProposalAsync = async (
  input: Parameters<RunCopilotToolProposal>[0]
): Promise<CopilotBrowserToolResult> => {
  const { runCopilotToolProposal: runProposal } = await loadCopilotApplyModule();

  return runProposal(input);
};
